/** @format */
import {
    largeButtonSizeStyles,
    mediumButtonSizeStyles,
} from '@mpb-com/feather/components/atoms/button/button.styles';
import { css } from 'styled-components';

import { largeTablet } from '@toucan/client/global/application';

const baseStyles = () => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: var(--layout-spacing-48);
    box-shadow: var(--effects-shadow-base);
    border-radius: 1.6rem;
    background-color: var(--colors-surface-primary);

    .join-now-heading {
        margin-bottom: var(--layout-spacing-16);
    }

    .join-now-content {
        margin-bottom: var(--layout-spacing-24);
    }

    .join-now-button {
        ${largeButtonSizeStyles};
        width: 30rem;
    }

    ${largeTablet(css`
        .join-now-button {
            ${mediumButtonSizeStyles};
            width: 18rem;
        }
    `)}
`;

export const styles = () => css`
    ${baseStyles()}
`;
